<app-resource-builder-question-form
    [group]="group"
    [question]="question | async"
    [editable]="editable"
    [usePoints]="usePoints"
></app-resource-builder-question-form>
